/** Routes de l'application (dans le fragment d'URL : site statique, rien côté serveur). */
import type { GameKind } from '../game/protocol';
import { isValidRoomId } from '../net/invite';

export type Route =
  | { readonly name: 'home' }
  | { readonly name: 'solo' }
  /** « Imite ce smiley » en solo : série de 3 smileys, score sur 100. */
  | { readonly name: 'smiley-solo' }
  /** Vérification caméra, analyse et réseau avant de jouer. */
  | { readonly name: 'diagnostic' }
  /** Hôte : salle d'attente (jeu présélectionné depuis l'accueil) puis partie. */
  | { readonly name: 'host'; readonly game: GameKind }
  /** Invité : lien d'invitation. */
  | { readonly name: 'join'; readonly roomId: string };

export function parseRoute(hash: string): Route {
  if (hash === '#/solo') return { name: 'solo' };
  if (hash === '#/smiley-solo') return { name: 'smiley-solo' };
  if (hash === '#/partie') return { name: 'host', game: 'barbichette' };
  if (hash === '#/chifoumi') return { name: 'host', game: 'chifoumi' };
  if (hash === '#/smiley') return { name: 'host', game: 'smiley' };
  if (hash === '#/diagnostic') return { name: 'diagnostic' };
  const join = /^#\/j\/(.+)$/.exec(hash)?.[1];
  if (join !== undefined && isValidRoomId(join)) return { name: 'join', roomId: join };
  return { name: 'home' };
}

export function routeHash(route: Route): string {
  switch (route.name) {
    case 'home':
      return '';
    case 'solo':
      return '#/solo';
    case 'smiley-solo':
      return '#/smiley-solo';
    case 'host':
      return route.game === 'barbichette' ? '#/partie' : `#/${route.game}`;
    case 'diagnostic':
      return '#/diagnostic';
    case 'join':
      return `#/j/${route.roomId}`;
  }
}

/** Quitter une partie À DEUX en cours prévient l'ami : on demande confirmation. */
export function needsConfirmation(from: Route, to: Route, gameInProgress: boolean): boolean {
  if (from.name === to.name) return false;
  return gameInProgress && (from.name === 'host' || from.name === 'join');
}
